import { render, staticRenderFns } from "./ChatBaloon.vue?vue&type=template&id=eb932730&scoped=true&"
import script from "./ChatBaloon.vue?vue&type=script&lang=js&"
export * from "./ChatBaloon.vue?vue&type=script&lang=js&"
import style0 from "./ChatBaloon.vue?vue&type=style&index=0&id=eb932730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb932730",
  null
  
)

export default component.exports